<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Herr+Von+Muellerhoff&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

.signature-input {
  padding: 0px 15px 5px 15px;
  font-size: 22pt;
  font-family: 'Yellowtail', cursive;
  height: auto !important;
}


@media only screen and (max-width: 600px) {
  .signature-input {
    font-size: 20pt;
    font-family: 'Yellowtail', cursive;
  }
}

@media only screen and (max-width: 480px) {
  .signature-input {
    font-size: 14pt;
    font-family: 'Yellowtail', cursive;
  }
}

/*label {*/
/*    font-size: 1.5em;*/
/*}*/

.toggle {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>

<template>
  <div class="uk-grid">
    <div class="uk-width-medium-1-1 uk-width-small-1-1" v-if="completed">
      <h2 class="signature-input uk-margin-top uk-margin-bottom">{{ name }} </h2>
    </div>
    <div class="uk-width-medium-1-1 uk-width-small-1-1" v-else>
      <div>
        <h4 aria-label="name"><i>{{ name }}</i></h4>
      </div>
      <div class="uk-margin-top uk-flex uk-flex-column">
        <div class="uk-flex uk-flex-row">
          <toggle-button :color="color" :value="signatureMatches" :sync="true" :disabled="true" class="toggle"/>
          <span v-if="signatureMatches">{{ __('tenant.i_agree') }}</span>
          <span v-else>{{ __('tenant.type_name') }}</span>
        </div>

      </div>
      <form autocomplete="off" @submit.prevent="() => {}">
        <input autocomplete="off" ref="signature-input" :value="signatureText"
               aria-label="name"
               @input="onInput"
               @keypress="onInputChanged" type="text" class="signature-input">
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignatureBox",
  props: {
    name: {
      type: String,
      default: '',
    },
    isSigned: {
      type: Boolean,
      default: false,
    },
    userKey: {
      type: String,
      default: '',
    },
    typeKey: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: '#75c791',
    },
    completed: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      signatureText: '',
    }
  },
  watch: {
    isSigned(newValue) {
      if(!!newValue) {
        this.signatureText = this.name;
      } else {
        this.signatureText = '';
      }
    }
  },
  computed: {
    signatureMatches() {
      return this.cleanInput(this.signatureText) === this.cleanInput(this.name) && this.cleanInput(this.name);
    }
  },
  mounted() {
    if(this.isSigned) {
      this.signatureText = this.name;
    }
    if (this.$refs['signature-input'])
    {
      this.$refs['signature-input'].onpaste = e => {
        e.preventDefault();
      }
    }
  },
  methods: {
    cleanInput(input) {
      return input.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    },
    reset() {
      this.signatureText = ''
    },

    onInput($event) {
      this.signatureText = $event.target.value;
      let matches = this.cleanInput(this.signatureText) === this.cleanInput(this.name) && this.cleanInput(this.name);
      this.$emit('updated', {
        name: this.name,
        isSigned: matches,
        key: this.userKey,
        typeKey: this.typeKey,
      });
    },
    onInputChanged($event) {

    }
  }
}
</script>
